import workspaceQuery from '../../../graphql/queries/salesLedger/SalesTransactionWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/salesLedger/SalesTransactionListQuery.graphql';
import instanceQuery from '../../../graphql/queries/salesLedger/SalesTransactionQuery.graphql';
import defaultQuery from '../../../graphql/queries/salesLedger/SalesTransactionDefault.graphql';
import mutationQuery from '../../../graphql/mutations/salesLedger/SalesTransactionMutation.graphql';
import fragment from '../../../graphql/fragments/salesLedger/SalesTransactionFragment.graphql';
import aggregateQuery from '../../../graphql/queries/salesLedger/SalesTransactionAggregateQuery.graphql';
import { ALLOW_VIEW } from '../../../utils/OperationPermissions';

import { workspaceActionsForPermissions } from '../../../actions/salesLedger/SalesTransactionWorkspaceAction';
import { document } from '../../../utils/mailMergeFields';
import { EntityType } from '../../../@types/entityTypes';

export enum SalesTransactionActions {
  ViewInvoice = 'SALES_LEDGER_TRANSACTIONS_VIEW_INVOICE',
  PreviewPostings = 'SALES_LEDGER_TRANSACTIONS_PREVIEW_POSTINGS',
}

const actionsForPermissions = [
  { actionReference: SalesTransactionActions.ViewInvoice },
  { actionReference: SalesTransactionActions.PreviewPostings },
];

const SalesTransaction: EntityType = {
  type: 'SalesTransaction',
  title: 'Sales Transactions',
  formTitle: 'Sales Transaction',
  formUrl: '/Customers/Transaction/Details/',
  workspaceUrl: '/Customers/Transaction/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'documentNumber',
  },
  fragment,
  aggregate: aggregateQuery,
  screenReference: 'SALES_LEDGER_TRANSACTIONS',
  actions: [...actionsForPermissions, ...workspaceActionsForPermissions],
  operations: ALLOW_VIEW,
  mergeFields: document,
};

export default SalesTransaction;
